import React, { useEffect, useState, useRef, useContext } from 'react';
import { authManager } from '../utils/auth';
import $ from 'jquery';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from '../contexts/UserContext';

const Base_Url = process.env.REACT_APP_API_BASE_URL;

const Profile = () => {
    const [profileData, setProfileData] = useState(null);
    const [name, setName] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [qrCode, setQrCode] = useState('');
    const [mfaToken, setMfaToken] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [passwordRulesVisible, setPasswordRulesVisible] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const passwordInputRef = useRef(null);
    const rulesRef = useRef(null);
    const { setUser } = useContext(UserContext);

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                setIsLoading(true);
                const response = await authManager.authenticatedFetch(
                    `${Base_Url}/users/profile`
                );

                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }

                const data = await response.json();
                if (data?.result) {
                    setProfileData(data.result);
                } else {
                    throw new Error('Invalid response format');
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchUserProfile();
    }, []);

    useEffect(() => {
        $('.change_pwdclk').on('click', function (e) {
            e.preventDefault();
            $('.change_pwddiv').toggle(1000);
        });

        $('.change_2faclk').on('click', function (e) {
            e.preventDefault();
            $('.change_2fadiv').toggle(1000);
        });

        return () => {
            $('.change_pwdclk').off('click');
            $('.change_2faclk').off('click');
        };
    }, [isLoading]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                rulesRef.current &&
                !rulesRef.current.contains(event.target) &&
                passwordInputRef.current &&
                !passwordInputRef.current.contains(event.target)
            ) {
                setPasswordRulesVisible(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const fetchMfaQRCode = async () => {
            if (!authManager.isAuthenticated()) return;

            try {
                const response = await authManager.authenticatedFetch(`${Base_Url}/users/generate-mfa`, {
                    method: 'POST'
                });
                const data = await response.json();
                setQrCode(data.result.qrCodeDataURL);
            } catch (error) {
                if (process.env.NODE_ENV === 'development') {
                    console.error('Error generating MFA QR code:', error);
                }
            }
        };

        fetchMfaQRCode();
    }, []);

    useEffect(() => {
        if (profileData?.name) {
            setName(profileData.name);
        }
    }, [profileData]);

    const handleNameSubmit = async () => {
        try {
            const userId = localStorage.getItem("userId");

            if (!userId || !authManager.isAuthenticated()) {
                toast.error("Missing user session.");
                return;
            }

            const payload = {
                name,
                email: profileData?.email,
                role: profileData?.role,
                userStatus: profileData?.userStatus,
            };

            const response = await authManager.authenticatedFetch(`${Base_Url}/users/${userId}`, {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data?.status === "success") {
                setUser({ name: data.result.name });
                toast.success("Name updated successfully!");
            } else {
                toast.error(data?.message || "Failed to update name.");
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Server error.");
        }
    };




    const passwordRules = [
        { label: "At least 8 characters", test: (p) => p.length >= 8 },
        { label: "At least one uppercase letter", test: (p) => /[A-Z]/.test(p) },
        { label: "At least one lowercase letter", test: (p) => /[a-z]/.test(p) },
        { label: "At least one number", test: (p) => /[0-9]/.test(p) },
        { label: "At least one special character", test: (p) => /[!@#$%^&*(),.?":{}|<>]/.test(p) },
    ];

    const isPasswordValid = (pass) => {
        return passwordRules.every(rule => rule.test(pass));
    };

    const handleChangePassword = async () => {
        if (!newPassword || !confirmNewPassword) {
            setPasswordError("Please fill out both password fields.");
            return;
        }

        if (newPassword !== confirmNewPassword) {
            setPasswordError("Password do not match.");
            return;
        }

        if (!isPasswordValid(newPassword)) {
            setPasswordError("Password does not meet the required criteria.");
            return;
        }

        try {
            const userId = localStorage.getItem('userId');
            const response = await authManager.authenticatedFetch(`${Base_Url}/users/${userId}`, {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ newPassword })
            });

            const data = await response.json();

            if (data?.status === "success") {
                toast.success("Password updated successfully!");
                setNewPassword('');
                setConfirmNewPassword('');
                setPasswordRulesVisible(false);
            } else {
                toast.error(data?.message || "Password update failed.");
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Server error. Try again.");
        }
    };




    const handleMfaSubmit = async (e) => {
        e.preventDefault();

        const userId = localStorage.getItem('userId');

        if (!authManager.isAuthenticated() || !userId) {
            toast.error("Missing user session. Please log in again.");
            return;
        }

        if (!mfaToken.trim()) {
            toast.warning("Please enter the MFA code.");
            return;
        }

        try {
            const response = await authManager.authenticatedFetch(`${Base_Url}/users/verify-mfa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    mfaToken,
                    userId
                })
            });

            const data = await response.json();

            if (data.status_code === 200) {
                toast.success("2FA verified successfully!");
                setMfaToken('');
            }

        } catch (error) {
            const errorMsg = error.response?.data?.message || 
                           error.response?.data?.error?.message || 
                           "2FA verification failed.";
            toast.error(errorMsg);
        }
    };



    return (
        <div>
            <ToastContainer autoClose={3000} />
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2 align-items-center">
                        <div className="col-6 col-sm-6">
                            <h1 className="m-0 txt_lft">Profile</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="frmwdth_cntr">
                            <div className="col-lg-12">
                                <div className="card card-primary card-outline">
                                    {isLoading ? (
                                        <div className="card-body text-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    ) : error ? (
                                        <div className="card-body text-center">
                                            <div className="alert alert-danger">{error}</div>
                                        </div>
                                    ) : (
                                        <form className="form-horizontal" autoComplete="off">
                                            <div className="card-body">
                                                <div className="form-group row align-items-center">
                                                    <label className="col-12 col-md-4 col-form-label">Name</label>
                                                    <div className="col-12 col-md-8">
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={name}
                                                                onChange={(e) => setName(e.target.value)}
                                                                style={{ flex: 1, marginRight: '10px' }}
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-blue"
                                                                onClick={handleNameSubmit}
                                                            >
                                                                Save
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group row align-items-center">
                                                    <label className="col-12 col-md-4 col-form-label">Email</label>
                                                    <div className="col-12 col-md-8">
                                                        {profileData?.email || ''}
                                                    </div>
                                                </div>

                                                <div className="form-group row">
                                                    <label className="col-12 col-md-4 col-form-label">Password</label>
                                                    <div className="col-12 col-md-8">
                                                        <div className="mt-2 mb-3">
                                                            <div className="change_pwdclk">Change Password</div>
                                                        </div>
                                                        <div className="change_pwddiv" style={{ display: 'none' }}>
                                                            <div className="innerbox">
                                                                <div className="mb-2 w-100">
                                                                    <div className="input-group mb-3">
                                                                        <input
                                                                            ref={passwordInputRef}
                                                                            type="password"
                                                                            className="form-control"
                                                                            placeholder="New Password"
                                                                            autoComplete="New Password"
                                                                            value={newPassword}
                                                                            onChange={(e) => {
                                                                                setNewPassword(e.target.value);
                                                                                setPasswordError('');
                                                                            }}
                                                                            onFocus={() => setPasswordRulesVisible(true)}
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <div className="input-group-text">
                                                                                <i className="fas fa-lock" />
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                    <div
                                                                        ref={rulesRef}
                                                                        className={`password-rules-wrapper ${passwordRulesVisible ? 'show' : ''}`}
                                                                    >
                                                                        <ul className="mb-2" style={{ listStyle: 'none', paddingLeft: 0 }}>
                                                                            {passwordRules.map((rule, idx) => (
                                                                                <li key={idx} style={{ color: rule.test(newPassword) ? 'green' : 'gray' }}>
                                                                                    <i
                                                                                        className={`fa ${rule.test(newPassword) ? 'fa-check-circle' : 'fa-circle'}`}
                                                                                        style={{ marginRight: 6 }}
                                                                                    ></i>
                                                                                    {rule.label}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>

                                                                </div>
                                                                <div className="w-100">
                                                                    <div className="input-group mb-3">
                                                                        <input type="password"
                                                                            className="form-control"
                                                                            placeholder="Confirm New Password"
                                                                            value={confirmNewPassword}
                                                                            onChange={(e) => setConfirmNewPassword(e.target.value)}
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <div className="input-group-text">
                                                                                <i className="fas fa-lock" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {passwordError && (
                                                                    <div className="text-danger mb-2" style={{ fontSize: '0.9em' }}>{passwordError}</div>
                                                                )}
                                                                <div className="mt-3 d-inline-flex justify-content-center w-100">
                                                                    <div className="btn btn-blue" onClick={handleChangePassword}>Change Password</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group row">
                                                    <label className="col-12 col-md-4 col-form-label">2FA</label>
                                                    <div className="col-12 col-md-8">
                                                        <div className="mb-3">
                                                            <div className="change_2faclk">Change</div>
                                                        </div>
                                                        <div className="change_2fadiv" style={{ display: 'none' }}>
                                                            <div className="innerbox">
                                                                <div className="col-12 col-sm-12 col-md-12">
                                                                    <h5 className="login-box-msg mb-2">Authentication</h5>
                                                                    <div className="mb-3 text-center">
                                                                        Your account is protected with multi-factor authentication (MFA)
                                                                    </div>
                                                                    <div className="mb-4 text-center fwt_600 f_primary">
                                                                        Scan the QR code below
                                                                    </div>
                                                                    <div className="qrcode_scandiv text-center mt-3 mb-4">
                                                                        {qrCode ? (
                                                                            <img src={qrCode} alt="QR Code" />
                                                                        ) : (
                                                                            <p>Loading QR Code...</p>
                                                                        )}
                                                                    </div>
                                                                    <div className="mb-3 text-center">
                                                                        To finish setup, enter the code from your MFA device below.
                                                                    </div>
                                                                    <div className="mb-3 text-left fwt_600">
                                                                        MFA code
                                                                    </div>
                                                                    <div className="input-group mb-3">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Enter Code"
                                                                            value={mfaToken}
                                                                            onChange={(e) => setMfaToken(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-12 mt-3 text-center">
                                                                            <button type="button" className="btn btn-blue" onClick={handleMfaSubmit}>Submit</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;